module.exports = {
          srcSet: __webpack_public_path__ + "images/1978-09ed23a335daef8b54da30ae2bdc7ade-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1978-f20ce6b7a56ecb96feea608adc7d4911-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1978-09ed23a335daef8b54da30ae2bdc7ade-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1978-f20ce6b7a56ecb96feea608adc7d4911-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1978-09ed23a335daef8b54da30ae2bdc7ade-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1978-09ed23a335daef8b54da30ae2bdc7ade-320.jpg"},
          
          width: 320,
          height: 251
        }